import { map, tap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { Pagination } from '@core/models/pagination.model';
import { AllMemberReportSummary } from '@core/models/all-member-report-summary.model';
import { TransactionHttpService } from '@core/services/transaction-http.service';
import { AllMemberReport } from '@core/models/allmember-report.model';
import { TransactionReport } from '@core/models/transaction-report.model';

@Injectable()
export class AllMemberReportDataService extends DefaultDataService<AllMemberReport> {

  pagination: Pagination;
  summary: AllMemberReportSummary;
  messages$ = new Subject<any[]>();
  date = this.transactionHttpService.getToday();
  from = this.date.from;
  to = this.date.to;

  constructor(
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    private transactionHttpService: TransactionHttpService
  ) {
    super('MemberReport', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<AllMemberReport[]> {
    return this.http.get<ApiResponse>(`/report/allmemberreport`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows),
    );
  }

  getWithQuery(pageParam: string): Observable<AllMemberReport[]>{
    return this.http.get<ApiResponse>(`/report/allmemberreport?paginate=1${pageParam}`).pipe(
      tap(res => {
        this.paginationInit(res);
        this.getSummary(res);
      }),
      map(res => res.data.rows)
    );
  }

  getTransaction(pageParam: string): Observable<TransactionReport[]> {
    return this.http.get<ApiResponse>(`/report/transactionreport${pageParam}`).pipe(
      map(res => res.data.rows)
    );
  }

  exportReport (pageParam: string) {
    return this.http.get<ApiResponse>(`/report/exportallmemberreport${pageParam}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  exportGameProviderDetail (pageParam: string) {
    return this.http.get<ApiResponse>(`/report/exportgameproviderdetail${pageParam}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  exportBetHistory (pageParam: string) {
    return this.http.get<ApiResponse>(`/report/exportbethistories${pageParam}`).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      return this.pagination = res.data.paginations;
    }
  }

  private getSummary(res: any) {
    if (res) {
      return this.summary = res.data.summary;
    }
  }

}
